import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

function readPageTitle() {
  const main = document.getElementById("main-portal");
  const h1 = main?.querySelector("h1");
  const fromHeading = h1?.textContent?.trim();
  if (fromHeading) return fromHeading;
  const docTitle = document.title?.trim();
  return docTitle || null;
}

export default function RewampRouteAnnouncer() {
  const location = useLocation();
  const [message, setMessage] = useState("");
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const frame = requestAnimationFrame(() => {
      const title = readPageTitle();
      if (title) setMessage(title);
    });

    return () => cancelAnimationFrame(frame);
  }, [location.pathname, location.search, location.hash]);

  return (
    <Box aria-live="polite" aria-atomic="true" sx={visuallyHidden}>
      {message}
    </Box>
  );
}
